(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heritage-contact"]) return;
  try {
    
function populateHeritageInquiry() {
  const form = document.getElementById('HeritageContact');
  if (!form) return;
  const key = 'heritage-inquiry-context';
  const success = form.querySelector('.hcontact-success');
  const error = form.querySelector('.hcontact-errors');
  if (success) {
    try { sessionStorage.removeItem(key); } catch {}
    if (!success.dataset.focused) { success.dataset.focused = 'true'; success.focus(); }
    return;
  }
  const parameters = new URLSearchParams(location.search);
  const item = document.getElementById('ContactItem');
  const productLink = document.getElementById('ContactProductLink');
  const viewItem = document.getElementById('ContactViewItem');
  if (!item || !productLink) return;
  const validPath = path => typeof path === 'string' && /^\/products\/[a-z0-9-]+$/.test(path);
  let path = parameters.get('product') || '';
  let title = (parameters.get('item') || '').slice(0, 250);
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch {}
  if (saved && (typeof saved.savedAt !== 'number' || Date.now() - saved.savedAt > 30 * 60 * 1000)) {
    try { sessionStorage.removeItem(key); } catch {}
    saved = null;
  }
  // Restore only a failed submission; a fresh inquiry must not inherit another item.
  if (error && !parameters.has('product') && !parameters.has('item') && saved) {
    path = saved.path || '';
    title = typeof saved.item === 'string' ? saved.item.slice(0, 250) : '';
  }
  if (!item.value && title) item.value = title;
  productLink.value = validPath(path) ? location.origin + path : '';
  if (viewItem) {
    viewItem.hidden = !productLink.value;
    if (productLink.value) viewItem.href = productLink.value;
    else viewItem.removeAttribute('href');
  }
  if (error && !error.dataset.focused) { error.dataset.focused = 'true'; error.focus(); }
  if (!form.dataset.contextReady) {
    form.dataset.contextReady = 'true';
    form.addEventListener('submit', () => {
      try {
        const productURL = productLink.value ? new URL(productLink.value) : null;
        sessionStorage.setItem(key, JSON.stringify({
          item: item.value.slice(0, 250),
          path: productURL && productURL.origin === location.origin && validPath(productURL.pathname) ? productURL.pathname : '',
          savedAt: Date.now()
        }));
      } catch {}
    });
  }
}
populateHeritageInquiry();
document.addEventListener('DOMContentLoaded', populateHeritageInquiry, { once: true });
document.addEventListener('shopify:section:load', populateHeritageInquiry);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('heritage-feedback')) {
  customElements.define('heritage-feedback', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const buyers = new Set();
      this.cards = [...this.querySelectorAll('figure')].filter(card => { const buyer = card.querySelector('figcaption').textContent.trim(); if (buyers.has(buyer)) { card.hidden = true; return false; } buyers.add(buyer); return true; });
      for (let i = this.cards.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]]; }
      try {
        const previous = sessionStorage.getItem('heritage-last-feedback');
        if (this.cards.length > 1 && this.cards[0].textContent === previous) [this.cards[0], this.cards[1]] = [this.cards[1], this.cards[0]];
        sessionStorage.setItem('heritage-last-feedback', this.cards[0].textContent);
      } catch {}
      this.cards.forEach(card => this.querySelector('.hh-feedback-grid').append(card));
      this.compact = matchMedia('(max-width: 749px)'); this.compact.addEventListener('change', () => this.show(), options);
      this.index = 0; this.motion = matchMedia('(prefers-reduced-motion: reduce)'); this.paused = this.motion.matches;
      this.querySelector('.hh-review-controls').hidden = false;
      this.querySelector('[data-review-pause]').addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.querySelector('[data-review-next]').addEventListener('click', () => { this.paused = true; this.advance(); }, options);
      this.addEventListener('focusin', event => { if (event.target.matches(':focus-visible')) { this.paused = true; this.sync(); } }, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.paused = true; this.sync(); }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.show();
    }
    advance() { this.index = (this.index + 1) % this.cards.length; this.show(); }
    show() {
      this.cards.forEach((card, i) => { const visible = (i - this.index + this.cards.length) % this.cards.length < (this.compact.matches ? 1 : 3); card.hidden = !visible; if (visible && !this.motion.matches) card.animate?.([{ opacity: .35, transform: 'translateX(8px)' }, { opacity: 1, transform: 'translateX(0)' }], { duration: 650, easing: 'ease-out' }); });
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const button = this.querySelector('[data-review-pause]');
      button.textContent = this.paused ? button.dataset.play : button.dataset.pause;
      if (!this.paused && !document.hidden && this.isConnected) this.timer = setTimeout(() => this.advance(), 10000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heritage-slideshow"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('heritage-slideshow')) {
  customElements.define('heritage-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      if (!window.Shopify?.designMode) {
        const pairs = this.slides.map((slide, i) => ({ slide, dot: this.dots[i] }));
        for (let i = pairs.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pairs[i], pairs[j]] = [pairs[j], pairs[i]];
        }
        let openers = pairs.filter(pair => pair.slide.dataset.opening === 'true');
        try {
          const previous = sessionStorage.getItem('heritage-last-hero');
          if (openers.length > 1) openers = openers.filter(pair => pair.slide.dataset.slideKey !== previous);
        } catch {}
        if (openers.length) {
          const chosen = openers[Math.floor(Math.random() * openers.length)];
          pairs.splice(pairs.indexOf(chosen), 1); pairs.unshift(chosen);
        }
        try {
          const last = sessionStorage.getItem('heritage-last-hero');
          if (!openers.length && pairs.length > 1 && pairs[0].slide.dataset.slideKey === last) [pairs[0], pairs[1]] = [pairs[1], pairs[0]];
          sessionStorage.setItem('heritage-last-hero', pairs[0]?.slide.dataset.slideKey || '');
        } catch {}
        const dashboardMain = pairs.find(pair => pair.slide.dataset.dashboardMain === 'true');
        if (dashboardMain) { pairs.splice(pairs.indexOf(dashboardMain), 1); pairs.unshift(dashboardMain); }
        pairs.forEach(({ slide, dot }, i) => {
          this.querySelector('.hs-slides').append(slide);
          if (dot) { this.querySelector('.hs-dots').append(dot); dot.dataset.dot = i; dot.setAttribute('aria-label', dot.dataset.labelPattern.replace('__NUMBER__', String(i + 1))); dot.querySelector('span').textContent = String(i + 1).padStart(2, '0'); }
          slide.setAttribute('aria-label', `${i + 1} / ${pairs.length}`);
        });
        this.slides = pairs.map(pair => pair.slide);
        this.dots = pairs.map(pair => pair.dot).filter(Boolean);
      }
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.explicitPause = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.keyboardPause = false;
      this.editing = false;
      if (this.slides.length < 2) return;
      this.querySelector('.hs-controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true), options));
      this.querySelector('[data-pause]').addEventListener('click', () => {
        const paused = this.explicitPause || this.keyboardPause;
        this.explicitPause = !paused; this.keyboardPause = false; this.sync();
      }, options);
      this.addEventListener('focusin', event => {
        if (event.target.matches(':focus-visible') && !event.target.closest('[data-pause]')) { this.keyboardPause = true; this.sync(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.explicitPause = true; this.sync(); }, options);
      this.addEventListener('shopify:block:select', event => { const i = this.slides.indexOf(event.target.closest('[data-slide]')); if (i >= 0) { this.editing = true; this.go(i); } }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.sync(); }, options);
      this.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, { ...options, passive: true });
      this.addEventListener('touchend', event => { const dx = event.changedTouches[0].clientX - this.touchX; const dy = event.changedTouches[0].clientY - this.touchY; if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) this.go(this.index + (dx < 0 ? 1 : -1), true); }, { ...options, passive: true });
      this.go(0);
    }
    go(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { const active = i === this.index; slide.classList.toggle('is-active', active); slide.inert = !active; slide.setAttribute('aria-hidden', String(!active)); });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      const activeDot = this.dots[this.index];
      if (activeDot) this.querySelector('.hs-dots').scrollLeft = Math.max(0, activeDot.offsetLeft - this.querySelector('.hs-dots').offsetLeft - 40);
      this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.slides.forEach((slide, i) => slide.querySelector('img')?.setAttribute('fetchpriority', i === this.index ? 'high' : 'auto'));
      this.slides[this.index]?.querySelector('img')?.setAttribute('loading', 'eager');
      this.slides[(this.index + 1) % this.slides.length]?.querySelector('img')?.setAttribute('loading', 'eager');
      this.sync(manual ? 10000 : undefined);
    }
    sync(delay) {
      clearTimeout(this.timer);
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      const paused = this.explicitPause || this.keyboardPause;
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      if (!paused && !this.editing && !document.hidden && this.isConnected) this.timer = setTimeout(() => this.go(this.index + 1), delay || Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
